import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Alert, Spin } from "antd";
import TextStyles from "../../../components/Elements/TextStyles/TextStyles";
import { ReactComponent as BackIcon } from "../../../assets/svgs/back-button.svg";
import CardsBorder from "../../../components/Cards/CardsBorder";
import CustomerLevel from "./CustomerLevel";
import ProjectLevel from "./ProjectLevel";
import { fetchAllLicenses } from "../../../redux/license/licenseSlice";
import { getApi } from "../../../api/api_instance";
import { API_URLS } from "../../../api/apiUrls";

const getTotalProjectLicense = (totalProjectLicense = {}) =>
  Object.values(totalProjectLicense).reduce(
    (sum, license) => sum + (Number(license?.total) || 0),
    0,
  );

const LicenceDetailPage = ({ customerLicense = false }) => {
  const [selected, setSelected] = useState("customer");
  const [customerDetail, setCustomerDetail] = useState(null);
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const [customerLoading, setCustomerLoading] = useState(false);
  const [customerError, setCustomerError] = useState("");
  const [totalProjects, setTotalProjects] = useState(0);
  const [activeUsers, setActiveUsers] = useState(0);
  const [projectLicenseTotal, setProjectLicenseTotal] = useState(0);

  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  const { id } = useParams();
  const { customerId, projectId, userName, userId } = location.state || {};
  const activeCustomerId = id || customerId || userId || "";

  useEffect(() => {
    dispatch(fetchAllLicenses());
  }, [dispatch]);

  useEffect(() => {
    const fetchCustomerDetail = async () => {
      if (!activeCustomerId) return;

      setCustomerLoading(true);
      setCustomerError("");

      try {
        const response = await getApi({
          apiUrl: API_URLS.GET_CUSTOMER_BY_ID(activeCustomerId),
        });
        if (response?.success) {
          setCustomerDetail({
            ...(response.data || {}),
            totalActiveUsers: response.totalActiveUsers,
            totalProjects: response.totalProjects,
            totalProjectLicense: response.totalProjectLicense,
          });
          setActiveUsers(Number(response.totalActiveUsers) || 0);
          setTotalProjects(Number(response.totalProjects) || 0);
          setProjectLicenseTotal(
            getTotalProjectLicense(response.totalProjectLicense),
          );
        } else {
          setCustomerError(response?.message || "Failed to fetch customer");
        }
      } catch (error) {
        setCustomerError(error?.message || "Failed to fetch customer");
      } finally {
        setCustomerLoading(false);
      }
    };

    fetchCustomerDetail();
  }, [activeCustomerId, refreshTrigger]);

  useEffect(() => {
    const fetchCustomerStats = async () => {
      if (!activeCustomerId) return;

      let projectsResponse = null;
      // let usersResponse = null;

      try {
        projectsResponse = await getApi({
          apiUrl: API_URLS.GET_CUSTOMER_FILTERED_PROJECTS(
            10,
            0,
            "-createdAt",
            "",
            ""
          ),
          headers: { client: activeCustomerId },
        });
      } catch (err) {
        console.error("Failed to fetch projects for stats", err);
      }

      // try {
      //   usersResponse = await getApi({
      //     apiUrl: API_URLS.GET_ALL_CUSTOMER_USER(
      //       1,
      //       5,
      //       "-createdAt",
      //       activeCustomerId,
      //       ""
      //     ),
      //     headers: { client: activeCustomerId },
      //   });
      // } catch (err) {
      //   console.error("Failed to fetch users for stats", err);
      // }

      if (projectsResponse) {
        const totalCount = projectsResponse.total ?? projectsResponse.totalCount ?? projectsResponse.data?.total ?? projectsResponse.data?.length ?? 0;
        setTotalProjects(Number(totalCount) || 0);
      }

      // if (usersResponse) {
      //   const totalCount = usersResponse.total ?? usersResponse.totalCount ?? usersResponse.data?.total ?? usersResponse.data?.length ?? 0;
      //   setActiveUsers(Number(totalCount) || 0);
      // }
    };

    fetchCustomerStats();
  }, [activeCustomerId, refreshTrigger]);

  const displayCustomer = customerDetail || {};
  const displayName = displayCustomer.organization?.name || displayCustomer.name || userName || "-";
  const displayCustomerId = displayCustomer.userId || activeCustomerId || "-";
  const displayEmail = displayCustomer.email || "-";
  const displayStatus = displayCustomer.status || "-";
  const displayOrgName =
    displayCustomer.billing?.organizationName ||
    displayCustomer.organization?.name ||
    "-";
  const displayContact =
    displayCustomer.billing?.contactPersonName ||
    displayCustomer.billing?.billingContact?.contactPersonName ||
    "-";
    
  return (
    <div
      style={{
        paddingLeft: "20px",
        paddingRight: "20px",
        paddingBottom: "20px",
        backgroundColor: "#fff",
      }}
    >
      <div>
        {!customerLicense && (
          <div>
            <div
              className="flex justify-end text-xs"
              style={{ fontFamily: "Calibri" }}
            >
              <p>Home </p>
              <span> / </span>
              <p>License </p> <span> / </span>
              <TextStyles color="gradient"> License Detail Page</TextStyles>
            </div>
            <div className="flex justify-start">
              <div>
                <BackIcon
                  onClick={() => {
                    navigate("/license");
                  }}
                />
              </div>
              <div className="items-center mt-2">
                <TextStyles color="gradient" style={{ fontSize: "20px" }}>
                  License Detail Page
                </TextStyles>
              </div>
            </div>
          </div>
        )}

        <div className="py-2">
          <CardsBorder>
            {customerLoading ? (
              <div className="flex justify-center py-10">
                <Spin size="large" />
              </div>
            ) : customerError ? (
              <div className="px-4 py-3">
                <Alert type="error" message={customerError} showIcon />
              </div>
            ) : (
              <div className="px-16">
                {!customerLicense && (
                  <div className="flex justify-between">
                    <TextStyles
                      color="gradient"
                      style={{
                        fontSize: "20px",
                        fontWeight: 500,
                        marginLeft: "20px",
                      }}
                    >
                      CUSTOMER NAME: {displayName}
                    </TextStyles>
                  </div>
                )}
                {!customerLicense && (
                  <p
                    style={{
                      marginLeft: "20px",
                      fontSize: "16px",
                      fontWeight: "300",
                    }}
                  >
                    Customer ID: {displayCustomerId}
                  </p>
                )}

           

                <div className="grid grid-cols-4 gap-6 py-2">
                  <div className="text-center">
                    <p className="text-gray-600 text-sm font-medium mb-3">
                      Total Projects
                    </p>
                    <hr className="border-gray-200 mb-3" />
                    <p className="text-2xl font-semibold text-[#06513D]">
                      {totalProjects}
                    </p>
                  </div>
                  <div className="text-center">
                    <p className="text-gray-600 text-sm font-medium mb-3">
                      Active Users
                    </p>
                    <hr className="border-gray-200 mb-3" />
                    <p className="text-2xl font-semibold text-[#06513D]">
                      {activeUsers}
                    </p>
                  </div>
                  <div className="text-center">
                    <p className="text-gray-600 text-sm font-medium mb-3">
                      Customer License
                    </p>
                    <hr className="border-gray-200 mb-3" />
                    <p className="text-2xl font-semibold text-[#06513D]">
                      {(() => {
                        const subAdmin = displayCustomer.license?.sub_admin;
                        const subAdminTotal = (() => {
                          if (!subAdmin) return 0;
                          const totalField = subAdmin.total;
                          if (totalField && typeof totalField === "object") {
                            return Number(totalField.issued ?? totalField.total ?? 0) || 0;
                          }
                          return Number(totalField ?? 0) || 0;
                        })();

                        const mgmtView = displayCustomer.license?.management_view;
                        const mgmtViewTotal = (() => {
                          if (!mgmtView) return 0;
                          const totalField = mgmtView.total;
                          if (totalField && typeof totalField === "object") {
                            return Number(totalField.issued ?? totalField.total ?? 0) || 0;
                          }
                          return Number(totalField ?? 0) || 0;
                        })();

                        return subAdminTotal + mgmtViewTotal;
                      })()}
                    </p>
                  </div>
                  <div className="text-center">
                    <p className="text-gray-600 text-sm font-medium mb-3">
                      Project License
                    </p>
                    <hr className="border-gray-200 mb-3" />
                    <p className="text-2xl font-semibold text-[#06513D]">
                      {projectLicenseTotal}
                    </p>
                  </div>
                </div>
              </div>
            )}
          </CardsBorder>
        </div>

        <div className="pb-5">
          <CardsBorder>
            <div className="mx-10">
              <TextStyles
                color="gradient"
                style={{
                  fontSize: "20px",
                  fontWeight: 500,
                }}
              >
                LICENSES & FEATURES MANAGEMENT
              </TextStyles>
              <p className="font-light mt-[-10px]">
                Manage license quantities and feature access for this customer
              </p>
            </div>
          </CardsBorder>
        </div>

        <div className="pb-0">
          <div className="py-5">
            <div className="flex w-full mt-4 overflow-hidden rounded-t-2xl border-b border-[#06513D]">
              <div
                className={`flex-1 text-center py-3 text-lg font-semibold cursor-pointer transition-all duration-200 ${
                  selected === "customer"
                    ? "bg-[#06513D] text-white"
                    : "bg-white text-[#06513D] hover:bg-[#F8F8F8]"
                }`}
                onClick={() => setSelected("customer")}
              >
                CUSTOMER-LEVEL
              </div>
              <div
                className={`flex-1 text-center py-3 text-lg font-semibold cursor-pointer transition-all duration-200 ${
                  selected === "project"
                    ? "bg-[#06513D] text-white"
                    :"bg-white text-[#06513D] hover:bg-[#F8F8F8]"
                }`}
                onClick={() => setSelected("project")}
              >
                PROJECT-LEVEL
              </div>
            </div>
          </div>
        </div>

        <div>
          {selected === "customer" ? (
            <CustomerLevel 
              customerId={activeCustomerId} 
              customerDetail={displayCustomer} 
              onSuccess={() => setRefreshTrigger(prev => prev + 1)}
            />
          ) : (
            <ProjectLevel
              projectId={projectId}
              clientId={activeCustomerId}
              onProjectLicenseChange={setProjectLicenseTotal}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default LicenceDetailPage;
